import React, { FormEvent, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Input from "../../../shared/input"
import { setLoading } from "../../../redux/loading"
import { setCreationMode, setUserId } from "../../../redux/inscription"
import { IRedux } from "../../../services/types"
import { emailIsRequiredFor } from "../../../services/helper"
import UserApi from "../../../services/api/User.api"
import MessageError from "../../../shared/message.error"

const CreateUser = () => {
  const dispatch = useDispatch()

  const domainId = useSelector((state: IRedux) => state.event.domainId)

  const [firstName, setFirstName] = useState<string>("")
  const [lastName, setLastName] = useState<string>("")
  const [email, setEmail] = useState<string>("")
  const [error, setError] = useState<string>("")

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError("")

    try {
      dispatch(setLoading(true))
      // Create user
      const user = await new UserApi().create({
        firstName,
        lastName,
        email
      })
      dispatch(setUserId(user.id))
    } catch (err) {
      setError(err.message)
    } finally {
      dispatch(setLoading(false))
    }
  }

  return (
    <div className="form">
      <form onSubmit={onSubmit} className="field">
        <Input
          value={firstName}
          onChange={setFirstName}
          type="text"
          label="Prénom"
          minLength={2}
          required
          focus
        />
        <Input
          value={lastName}
          onChange={setLastName}
          type="text"
          label="Nom"
          minLength={2}
          required
        />
        <Input
          value={email}
          onChange={setEmail}
          type="email"
          label={emailIsRequiredFor(domainId) ? "Email" : "Email (optionnel)"}
          required={emailIsRequiredFor(domainId)}
        />
        <MessageError message={error} />
        <div className="buttons is-centered field">
          <button
            type="button"
            className="button is-dark"
            onClick={e => {
              e.preventDefault()
              dispatch(setCreationMode())
            }}
          >
            Retour
          </button>
          <button type="submit" className="button is-primary">
            Créer
          </button>
        </div>
      </form>
    </div>
  )
}

export default CreateUser
